const isDev = process.env.NODE_ENV !== "production";
let debugEnabled = isDev;

try {
  // Allow enabling debug in production via localStorage flag or global window flag
  if (typeof window !== "undefined") {
    if (window.__SL_DEBUG__ || localStorage.getItem("SL_DEBUG") === "1") {
      debugEnabled = true;
    }
  }
} catch (e) {
  // ignore
}

const debug = (...args) => {
  if (debugEnabled) console.debug(...args);
};
const info = (...args) => console.info(...args);
const warn = (...args) => console.warn(...args);
const error = (...args) => console.error(...args);

const logger = {
  debug,
  info,
  warn,
  error,
};

export default logger;

export { debug, info, warn, error };
